module.exports = __webpack_public_path__ + "98dd327369fd974b73e085163d74449b.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/monsters/monster-9.png
// module id = 1661
// module chunks = 0